import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import academicModal from "models/academic.modal";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import ProductModal from "models/Product.modal";

const EditProduct = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [addBtnLoading, setAddBtnLoading] = useState(false);
  const navigate = useNavigate();
  const params = useParams();

  const location = useLocation();
  // Check if the current route matches the desired route path

  const handleSubmit = (event) => {
    setAddBtnLoading(true);
    event.preventDefault();
    const form = new FormData(event.target);

    // Simulate product update
    setTimeout(() => {
      helper.sweetalert.toast("Product updated successfully", "success");
      navigate(`/admin/product`);
      setAddBtnLoading(false);
    }, 1000);
  };

  const [productData, setProductData] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [image3, setImage3] = useState(null);
  const [image4, setImage4] = useState(null);
  const getData = async () => {
    if (params?.id) {
      setIsLoading(true);
      
      // Dummy product data based on ID
      const dummyProducts = {
        "1": {
          name: "Mathematics Complete Course - Class 10",
          normal_price: "2999",
          discounted_price: "1999",
          description: "Comprehensive mathematics course covering all topics for Class 10 CBSE curriculum. Includes algebra, geometry, trigonometry, and statistics with detailed explanations and practice problems.",
          banner: {
            image: "https://via.placeholder.com/300x200/0000FF/FFFFFF?text=Math+Course"
          },
          image1: {
            image: "https://via.placeholder.com/300x200/0066FF/FFFFFF?text=Algebra"
          },
          image2: {
            image: "https://via.placeholder.com/300x200/3399FF/FFFFFF?text=Geometry"
          },
          image3: {
            image: "https://via.placeholder.com/300x200/66CCFF/000000?text=Trigonometry"
          },
          image4: {
            image: "https://via.placeholder.com/300x200/99DDFF/000000?text=Statistics"
          }
        },
        "2": {
          name: "Physics Masterclass - Class 12",
          normal_price: "3499",
          discounted_price: "2499",
          description: "Advanced physics course for Class 12 students covering mechanics, thermodynamics, electromagnetism, and modern physics. Perfect for JEE and board exam preparation.",
          banner: {
            image: "https://via.placeholder.com/300x200/FF0000/FFFFFF?text=Physics+Course"
          },
          image1: {
            image: "https://via.placeholder.com/300x200/FF3333/FFFFFF?text=Mechanics"
          },
          image2: {
            image: "https://via.placeholder.com/300x200/FF6666/FFFFFF?text=Thermodynamics"
          },
          image3: {
            image: "https://via.placeholder.com/300x200/FF9999/000000?text=Electromagnetism"
          },
          image4: {
            image: "https://via.placeholder.com/300x200/FFCCCC/000000?text=Modern+Physics"
          }
        },
        "3": {
          name: "Chemistry Foundation - Class 11",
          normal_price: "2799",
          discounted_price: "1899",
          description: "Foundation chemistry course for Class 11 covering organic, inorganic, and physical chemistry. Includes practical experiments and theory explanations.",
          banner: {
            image: "https://via.placeholder.com/300x200/00FF00/FFFFFF?text=Chemistry+Course"
          },
          image1: {
            image: "https://via.placeholder.com/300x200/33FF33/FFFFFF?text=Organic"
          },
          image2: {
            image: "https://via.placeholder.com/300x200/66FF66/FFFFFF?text=Inorganic"
          },
          image3: {
            image: "https://via.placeholder.com/300x200/99FF99/000000?text=Physical"
          },
          image4: {
            image: "https://via.placeholder.com/300x200/CCFFCC/000000?text=Practicals"
          }
        }
      };
      
      setTimeout(() => {
        setIsLoading(false);
        const productData = dummyProducts[params.id] || dummyProducts["1"];
        setProductData(productData);
        setBannerImage(productData?.banner?.image);
        setImage1(productData?.image1?.image);
        setImage2(productData?.image2?.image);
        setImage3(productData?.image3?.image);
        setImage4(productData?.image4?.image);
      }, 1000);
    }
  }
  const handleFileChange = (event, setImage) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };
  useEffect(() => {
    getData();
  }, [])
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">
                  <span>Edit Product</span>
                </h3>
              </CardHeader>

              <CardBody>
                {isLoading ? (
                  <>Please Wait...</>
                ) : (
                  <div>
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <Label for="name"> Product Name</Label>
                            <Input
                              id="name"
                              name="name"
                              placeholder="Enter Name"
                              defaultValue={productData?.name}
                            />
                          </FormGroup>
                        </Col>

                      </Row>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="exampleEmail">Price (Normal)</Label>
                            <Input
                              id="normal_price"
                              name="normal_price"
                              placeholder="Enter Ammount"
                              type="number"
                              defaultValue={productData?.normal_price}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="exampleEmail"> Discount Price </Label>
                            <Input
                              id="discounted_price"
                              name="discounted_price"
                              placeholder="Enter Discount Ammount"
                              type="number"
                              defaultValue={productData?.discounted_price}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="banner">Banner Image</Label>
                              <Input
                                style={{
                                  border: "1px solid lightgrey",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                }}
                                id="banner"
                                name="banner"
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, setBannerImage)}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            {bannerImage && <img src={bannerImage} height={80} alt="Banner Preview" />}
                          </Col>
                        </Row>

                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="image1">Product Image 1</Label>
                              <Input
                                style={{
                                  border: "1px solid lightgrey",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                }}
                                id="image1"
                                name="image1"
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, setImage1)}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            {image1 && <img src={image1} height={80} alt="Product Image 1 Preview" />}
                          </Col>
                        </Row>

                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="image2">Product Image 2</Label>
                              <Input
                                style={{
                                  border: "1px solid lightgrey",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                }}
                                id="image2"
                                name="image2"
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, setImage2)}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            {image2 && <img src={image2} height={80} alt="Product Image 2 Preview" />}
                          </Col>
                        </Row>

                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="image3">Product Image 3</Label>
                              <Input
                                style={{
                                  border: "1px solid lightgrey",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                }}
                                id="image3"
                                name="image3"
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, setImage3)}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            {image3 && <img src={image3} height={80} alt="Product Image 3 Preview" />}
                          </Col>
                        </Row>

                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="image4">Product Image 4</Label>
                              <Input
                                style={{
                                  border: "1px solid lightgrey",
                                  padding: "6px 10px",
                                  borderRadius: "6px",
                                }}
                                id="image4"
                                name="image4"
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(e, setImage4)}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            {image4 && <img src={image4} height={80} alt="Product Image 4 Preview" />}
                          </Col>
                        </Row>
                      </div>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <Label for="description"> Product  Description</Label>
                            <Input
                              id="description"
                              name="description"
                              type="textarea"
                              placeholder="Enter Description"
                              defaultValue={productData?.description}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          color="secondary"
                          onClick={() => {
                            navigate('/admin/product');
                          }}
                        >
                          Cancel
                        </Button>

                        {addBtnLoading ? (
                          <Loader color={"blue"} />
                        ) : (
                          <Button
                            color="primary"
                            type="submit"
                            style={{ float: "right", marginLeft: "5%", backgroundColor: "#080278", color: "white", border: "none" }}
                          >
                            Save
                          </Button>
                        )}
                      </div>
                    </Form>
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};




export default EditProduct